var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote-tip"},[_vm._v("\n  "+_vm._s(_vm.tipText)+"\n  "),_c('div',[_vm._v("*选项顺序为系统自动排序")])])}
var staticRenderFns = []

export { render, staticRenderFns }